<template>
    <div>
        <Breadcrumb :breadcrumb="breadcrumb"/>
        <div class="register">
            <b-container>
                <div class="pt-5 pb-5">
                    <FormRegister/>
                </div>
            </b-container>
        </div>
    </div>
</template>
<script>
import utils from '~/mixins/utils';
import Breadcrumb from '~/components/Breadcrumb';
import FormRegister from "~/components/Form-register";
export default{
    head() {
        return {
            title: 'Registre-se',
            meta: [
                {
                    hid: `twitter:card`,
                    name: 'twitter:card',
                    content: "summary_large_image"
                },
                {
                    hid: `og:title`,
                    property: 'og:title',
                    content: 'Registre-se'
                },
                {
                    hid: `og:url`,
                    property: 'og:url',
                    content: `${this.$host}${this.$route.fullPath}`
                },
                {
                    hid: `og:image`,
                    property: 'og:image',
                    content: this.imageUrl(this.$wdconfig.default.logo)
                },
                {
                    hid: 'og:image:height',
                    property: 'og:image:height',
                    content: '315'
                },
                {
                    hid: 'og:image:width',
                    property: 'og:image:width',
                    content: '600'
                },
            ]
        }
    },
    mixins: [
        utils
    ],
    components: {
        FormRegister,
        Breadcrumb,
    },
    computed: {
        breadcrumb() {
            let breadcrumb = [
                {
                    name: 'Home',
                    link: '/'
                }
            ];
            breadcrumb.push({
                        name: 'Cadastre-se',
                link: null
            });
            return breadcrumb;
        },
    }
}
</script>
